export const iconFontAwesomeSecuritySquarePersonConfined = (
	<i className="fa-solid fa-square-person-confined"></i>
);
